export function getAll(fetch, filtros) {
  return fetch().post("/analisereposicao", filtros);
}

export function save(fetch, dados) {
  return fetch().post("/AnaliseReposicao/gerar", dados);
}

export function sendEmail(fetch, dados) {
  return fetch().post("/AnaliseReposicao/sendemail", dados);
}

export function getDetalhe(id) {
  return new Promise((res, req) => {
    setTimeout(() => {
      res({
        data: detalhe,
      });
    }, 1000);
  });
}

const detalhe = [
  { id: 1, nome: "AREIA MEDIA M3", un: "M3", embalagem: null, sugestao: 80, pedido: 80 },
  { id: 2, nome: "CIMENTO CSN CP II 50 KG", un: "PC", embalagem: 1, sugestao: 87, pedido: 87 },
  { id: 3, nome: "7898962302019 AREIA MEDIA SACO 20 KG", un: "SC", embalagem: null, sugestao: 184, pedido: 184 },
  { id: 4, nome: "742832820240 CIMENTO CSN CP III 50 KG", un: "PC", embalagem: 1, sugestao: 85, pedido: 85 },
];
const data = [
  {
    id: "01",
    ean: "00002",
    codigo: "123456",
    nome: "TESTE 1",
    un: "UN TESTE",
    fabricante: "tigre",
    setor: "Hidraulica",
    grupo: "Tigre",
    embalagem: 12,
    valor: 180,
    cmv: 100,
    qtd: 25,
    estoque: 25,
    estoqueMin: 1,
    estoqueMax: 5000,
    giro: 110,
  },
  {
    id: "03",
    ean: "00003",
    codigo: "123456",
    nome: "TESTE 1",
    un: "UN TESTE",
    fabricante: "tigre",
    setor: "Hidraulica",
    grupo: "Tigre",
    embalagem: 12,
    valor: 180,
    cmv: 100,
    qtd: 25,
    estoque: 25,
    estoqueMin: 1,
    estoqueMax: 5000,
    giro: 110,
  },
  {
    id: "02",
    ean: "00002",
    codigo: "123456",
    nome: "TESTE 1",
    un: "UN TESTE",
    fabricante: "tigre",
    setor: "Hidraulica",
    grupo: "Tigre",
    embalagem: 12,
    valor: 180,
    cmv: 100,
    qtd: 25,
    estoque: 25,
    estoqueMin: 1,
    estoqueMax: 5000,
    giro: 110,
  },
];
